<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded" :caption="this.isLoaded ? 'Свернуть' : 'Загрузить'" :expandable="true" :printActions="printActions">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div>
        <tr><td align="left" colspan="2"> Финансовая отчетность (тыс.р.)</td></tr> 
        </div><br/>
      </div>
    </v-panel-title>
    <v-card-text v-show="isLoaded" class="pt-0">
      <div v-if = "isLoaded">
      <table width="100%">  
        <tr>
          <th align="left" :colspan="years.length">Бухгалтерский баланс</th>
        </tr> 
        <tr v-html="formatHeaders()">          
        </tr>
        <template v-for="item in this.getPartItems(0, 20000)">          
        <tr v-if="item">
          <td :colspan="years.length"> <b>{{Math.trunc(item.code / 10)}}</b> {{item.name}}</td></tr> 
        <tr v-if="item" v-html="formatValues(item)">
        </tr>
        </template>
      </table>
      <br/>
      <table width="100%">  
        <tr>
          <th align="left" :colspan="years.length">Отчет о прибылях и убытках</th>
        </tr> 
        <tr v-html="formatHeaders()">          
        </tr>
        <template v-for="item in this.getPartItems(20000, 30000)">          
        <tr v-if="item">
          <td :colspan="years.length"> <b>{{Math.trunc(item.code / 10)}}</b> {{item.name}}</td></tr> 
        <tr v-if="item" v-html="formatValues(item)">
        </tr>
        </template>
      </table>
      <br/>
      <table width="100%">  
        <tr>
          <th align="left" :colspan="years.length">Отчет об изменениях капитала</th>
        </tr> 
        <tr v-html="formatHeaders()">          
        </tr>
        <template v-for="item in this.getPartItems(30000, 40000)">          
        <tr v-if="item">
          <td :colspan="years.length"> <b>{{Math.trunc(item.code / 10)}}</b> {{item.name}}</td></tr> 
        <tr v-if="item" v-html="formatValues(item)">
        </tr>
        </template>
      </table>
      <br/>
      <table width="100%">  
        <tr>
          <th align="left" :colspan="years.length">Отчет о движении денежных средств</th>
        </tr> 
        <tr v-html="formatHeaders()">          
        </tr>
        <template v-for="item in this.getPartItems(40000, 50000)">          
        <tr v-if="item">
          <td :colspan="years.length"> <b>{{Math.trunc(item.code / 10)}}</b> {{item.name}}</td></tr> 
        <tr v-if="item" v-html="formatValues(item)">
        </tr>
        </template>
      </table>
      <br/>
      <table width="100%">  
        <tr>
          <th align="left" :colspan="years.length">Отчет о целевом использовании полученных средств</th>
        </tr> 
        <tr v-html="formatHeaders()">          
        </tr>
        <template v-for="item in this.getPartItems(60000, 70000)">
        <tr v-if="item">
          <td :colspan="years.length"> <b>{{Math.trunc(item.code / 10)}}</b> {{item.name}}</td></tr> 
        <tr v-if="item" v-html="formatValues(item)">
        </tr>
        </template>
      </table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  // import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import classes from '../../api/classes'

  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-fin-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      items: [],
      years: [],
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          // this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderDateSince: 'renderDateSince'
      }),
      balanceItems () {
        return this.items.filter(i => i.code < 20000)
      },
      printActions () {
        var result = []
        result.push(new classes.Action(this, 'Pdf', null, () => this.print('pdf')))
        result.push(new classes.Action(this, 'Экспорт в docx', null, () => this.print('docx')))
        result.push(new classes.Action(this, 'Экспорт в odt', null, () => this.print('odt')))
        result.push(new classes.Action(this, 'Экспорт в rtf', null, () => this.print('rtf')))
        return result
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded) {
          this.fetchItems()
        }
      },
      getPartItems (from, to) {
        return this.items.filter(i => i.code > from && i.code < to)
      },
      formatCurrency (number) {
        return number != null ? (number >= 0 ? formats.formatCurrency(number) : '(' + formats.formatCurrency(Math.abs(number)) + ')') : ''
      },
      formatHeaders () {
        var result = ''
        var years = this.years
        if (years) {
          var width = Math.trunc(100 / years.length)
          years.forEach(k => {
            var template = `<th align="right" width="${width}%">${k.year} г. </th>`
            result = result + template
          })
        }
        return result
      },
      formatValues (item) {
        var result = ''
        var years = this.years
        if (item && years) {
          var lastKey = years[years.length - 1]
          years.forEach(k => {
            var value = this.formatCurrency(item.values[k.year])
            if (k === lastKey) {
              value = `<b>${value}</b>`
            }
            var template = `<td align="right">${value}</td>`
            result = result + template
          })
        }
        return result
      },
      formatCounter (item) {
        return `<tr><td colspan="${this.years.length}"> <b>${Math.trunc(item.code / 10)}</b> ${item.name}</td></tr> 
        <tr>${this.formatValues(item)}</tr>`
      },
      print (format) {
        let url = server.getBaseUrl() + '/openapi/companies/' + this.ogrn + '/fin/year_statements/redirect?format=' + format
        this.$store.dispatch('openLocation', url)
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении финансового отчета '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/fin/year_statements',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.years = []
          this.items = []
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.isLoading = false
            this.years = data.years
            this.items = data.counters
          })
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// FinPanel.vue?ec846060